module.exports = __webpack_public_path__ + "fonts/Inter-800-cyrillic72.fdccea7.woff2";